import { api } from '@/global/services/api'
import { isFunction } from '@/global/utils/utils'
import { WINTER_SERVICE_MODULE } from '@/modules/road-maintenance-module/winter-service-v2/common/config/constants'
import {
  TASKS_ENDPOINT,
  TASKS_INDEX_ROUTE,
  TASKS_TRANSLATION_NAMESPACE as NS
} from '@/modules/road-maintenance-module/winter-service-v2/tasks/config/constants'

/**
 * What the task-level button in the details header does - deleting the task on screen.
 * The header itself sits above the tab strip and is shared by both tabs. `Duplicate` and
 * `Create PDF` from the design have no endpoint behind them yet and are left out; a task
 * is created from the listing, which is where a new one belongs.
 */
export function useTaskHeaderActions (options) {
  const {
    translate,
    router,
    taskId,
    openInfoDialogFn,
    closeInfoDialogFn,
    setInfoDialogLoaderFn
  } = options || {}

  const deleteTask = async () => {
    try {
      if (!taskId) {
        return
      }

      setInfoDialogLoaderFn?.(true)
      await api(WINTER_SERVICE_MODULE).delete(`${TASKS_ENDPOINT}/${taskId}`)
      closeInfoDialogFn?.()
      // The record it was showing is gone, so there is nothing to go back to but the
      // listing. `replace` keeps the deleted task out of the history.
      router?.replace({ name: TASKS_INDEX_ROUTE })
    }
    catch (exception) {
      console.error(exception)
    }
    finally {
      setInfoDialogLoaderFn?.(false)
    }
  }

  const confirmDelete = () => {
    if (!isFunction(openInfoDialogFn)) {
      return
    }

    openInfoDialogFn({
      title: translate(`${NS}.delete_confirmation_title`),
      message: translate(`${NS}.delete_confirmation_message`),
      onConfirm: deleteTask
    })
  }

  return {
    confirmDelete
  }
}
